import { classList } from "@uniit/frontend-utils";
import React from "react";
import * as styles from "./IconText.module.css";

/**
 * @param {BaseProps<{ icon: string }>} props
 */
function IconText({ children, className, icon }) {
  return (
    <span className={classList`${className} ${styles.container}`}>
      <img alt="" src={icon} />
      <span>{children}</span>
    </span>
  );
}

export default IconText;
